export default "__VITE_ASSET__DCYFrdMe__"